import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from '../../myjs/translate'

import React, { useState, useEffect, useLayoutEffect } from 'react'

import { getClassrooms, setClassroom, showClassroomsList, reset  } from '../../redux/classrooms/actions'

import { getLicenses, setActiveLicense } from '../../redux/licenses/actions'

import { getChallenges, showPublicChallengePage } from '../../redux/fundraiser/actions'

import { setActiveMission } from '../../redux/mission/actions'


function numberWithCommas(x) {
  try { 
    const number =  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return number;
  } catch (e) {
    return 0;
  }
}


const MenuBarLicenseSelector = ( props ) => {

  const dispatch = useDispatch()
  const translate = useTranslation( props )

  const classroom = useSelector( state => state.classrooms.classroom )
  const classroomName = useSelector( state => state.classrooms.classroom.name )

  const classroomsSorted = useSelector( state => state.classrooms.classroomsSorted )

  const licenseName = useSelector( state => state.licenses.license.name )
  const licensesSorted = useSelector( state => state.licenses.licensesSorted )

  const challengesSorted = useSelector ( state => state.fundraiser.challengesSorted )
 
  const [dropDownVisible, setDropDownVisible] = useState(false);

  useEffect(() => {
    if (license.isTeacher()) dispatch( getClassrooms() )
    dispatch( getLicenses() )
    dispatch( getChallenges() )
  }, [ ] ) 

  useLayoutEffect(() => {
    if (dropDownVisible) {
      $("body")[0].addEventListener('click',(e)=>{
        const $target = $(e.target);
        if(!$target.closest('.dropDown').length) actionToggleDropDown();
      }, true);
    }
  }, [ dropDownVisible] ) 

  useEffect(() => {
    $('.MenuBarLicenseSelectorTitle').animateCSS('flash')
  }, [ classroomName ] ) 

  const actionSelectClassroom = async ( classroom ) => {
    try {    
      await dispatch( setActiveMission( classroom, props ) )
      setDropDownVisible(false)
    } catch (e) {
      console.log(e)
    }
  }

  const actionManageClassrooms = () => {
    dispatch( showClassroomsList() )
    setDropDownVisible(false);
  }

  const actionSelectLicense = async ( license ) => {
    try {    
      await dispatch( setActiveMission( license, props ) )
      setDropDownVisible(false)
    } catch (e) {
      console.log(e)
    }
  }

  const actionAddFundraiser = async () => {
    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.showCreateChallenge' )
    setDropDownVisible(false);
  }

  const actionAddFundraiserTeam = async () => {
    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.showCreateTeam' )
    setDropDownVisible(false);
  }

  const actionAddLicense = () => {
      otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=license.showActivateLicense' )
      setDropDownVisible(false);
  }

  const actionShowChallenge = ( challenge ) =>  {
    console.log( challenge )
    dispatch( showPublicChallengePage( challenge ) )
    setDropDownVisible(false);
  }

  const classroomsList =  classroomsSorted.map( classroomItem => {

    const active = ( classroom.id === classroomItem.id && (
      <i className="fa fa-circle activeLicenseDot" aria-hidden="true"></i>
    ))

    return (
      <div key={classroomItem.id} data-mission-id={classroomItem.missionId} className="entry classroom" onClick = { () => actionSelectClassroom( classroomItem ) }>
        { classroomItem.name } ({ classroomItem.count }) { active }
      </div>
    )

  });

  var title = ( licensesSorted.length>0 ? '' : translate('OP_LS_NO_LICENSE') )

  var fundraisersList = []  

  var fundraiserTeamsList = []

  var teacherLicensesList = []

  var studentLicensesList = []

  var teamLicensesList = []

  licensesSorted.forEach( license => {

    const active = ( license.active && (
      <i className="fa fa-circle activeLicenseDot" aria-hidden="true"></i>
    ))

    const listing = (
      <div key={license.id} data-mission-id={license.missionId} className="entry license" onClick={ () => actionSelectLicense( license )}>
        { license.name } { ( license.raised && ( 
          <span> - ${ numberWithCommas(license.raised) } </span>  ) ) }
          { active }
      </div>
    )

    switch ( license.licenseType + '-' + license.missionType ) {
      case "1-1":
      case "4-1":
      case "8-1":
      case "11-1":

          studentLicensesList.push( listing )
          if ( active ) title = license.name
        break;
      case "4-2":
      case "8-2":
      case "11-2":
          
          teacherLicensesList.push( listing )
          if ( active ) title = classroomName
         break;
      case "13-3":
          teamLicensesList.push( listing )
          if ( active ) title = license.name
        break;
      case "19-3":
      case "20-3":
        fundraiserTeamsList.push ( listing )
        if ( active ) title = license.name
    }
  })

  challengesSorted.forEach( challenge => {
    const active = null
    const listing = (
      <div key={challenge.id} className="entry challenge" onClick={ () => actionShowChallenge( challenge )}>
        { challenge.name } { ( challenge.raised && ( 
          <span> - ${ numberWithCommas(challenge.raised) } </span>  ) ) }
          { active }
      </div>
    )

    fundraisersList.push(listing)

  })

  const listingWrapper = (
    <>
    <div className="dropDown">

      { ( licensesSorted.length==0 && (
        <div>
          {translate('OP_LS_NO_LICENSES')}
        </div>
      ) ) }

      { (  classroomsList.length>0 && license.isTeacher() && (
        <div className="licenseGroup classrooms">
          <div className="title">
          {translate('OP_LS_CLASSROOMS_TITLE')}
          </div>
          <div className="entries">
            { ( (classroomsList.length && classroomsList ) || translate('OP_LS_NO_CLASSROOMS_FOUND'))}
          </div>
          { ( props.showActions && (
              <div className="actions">
                <div className="action" onClick={ actionManageClassrooms }>
                  {translate('OP_LS_ADD_CLASSROOMS')}
                </div>
              </div>
          ))}
          </div>
      ) ) }

      { ( teacherLicensesList.length>0 && (
        <div className="licenseGroup teacherLicenses">
          <div className="title">
          {translate('OP_LS_TEACHER_LICENSES')}
          </div>
          <div className="entries">
            { ( (teacherLicensesList.length && teacherLicensesList) || translate('OP_LS_NO_TEACHER_LICENSES_FOUND'))}
          </div>
        </div>
      ) ) }

      { ( studentLicensesList.length>0 && (

      <div className="licenseGroup studenLicenses">
        <div className="title">
        {translate('OP_LS_STUDENT_LICENSES')}
        </div>
        <div className="entries">
          { ( (studentLicensesList.length && studentLicensesList) || translate('OP_LS_NO_STUDENT_LICENSES_FOUND'))}
        </div>
      </div>

      ) ) }

      { (fundraiserTeamsList.length>0 && (
      <div className="licenseGroup fundraiserTeams">
        <div className="title">
        {translate('OP_LS_FUNDRAISER_TEAMS')}
        </div>
        <div className="entries">
          { ( (fundraiserTeamsList.length && fundraiserTeamsList ) || translate('OP_LS_NO_FUNDRAISER_TEAMS_FOUND'))}
        </div>
        { ( props.showActions && false && (
          <div className="actions">
            <div className="action" onClick={ actionAddFundraiserTeam }>
              {translate('OP_LS_ADD_FUNDRAISER_TEAM')}
            </div>
          </div>
        ) ) }

      </div>
      )) }

      { ( teamLicensesList.length>0 && (

      <div className="licenseGroup teamLicenses">
        <div className="title">
        {translate('OP_LS_TEAM_LICENSES')}
        </div>
        <div className="entries">
          { ( (teamLicensesList.length && teamLicensesList) || translate('OP_LS_NO_STUDENT_LICENSES_FOUND'))}
        </div>
      </div>

      ) ) }
      
      { (!props.hideFundraisers && (
      <div className="licenseGroup fundraisers">
        <div className="title">
        {translate('OP_LS_FUNDRAISERS')}
        </div>
        <div className="entries">
          { ( (fundraisersList.length && fundraisersList ) || translate('OP_LS_NO_FUNDRAISER_FOUND'))}
        </div>
          { ( props.showActions && props.canCreateFundraiser && false && (
            <div className="actions">
              <div className="action" onClick={ actionAddFundraiser  }>
                {translate('OP_LS_ADD_FUNDRAISER')}
              </div>
            </div>
          ) )}

      </div>
      ))}


      { (!props.hideAddLicense && (

        <div className="actions">
            <div className="action" onClick={ actionAddLicense }>
              {translate('OP_LS_ADD_LICENSE')}
            </div>
        </div>
      )) }


    </div>
    <div className="dropDownBackdrop"></div>
    </>
  )

  const dropDown = ( ( dropDownVisible && (
    <>
      { listingWrapper }
    </>
  ) ) )

  const actionToggleDropDown = () => {
    setDropDownVisible(!dropDownVisible)
  }

  if (props.dropDown) {
    return (
      <div className="MenuBarLicenseSelector">
        
        <div className="MenuBarLicenseSelectorTitle" onClick= { actionToggleDropDown }>
          { title } <i className="fa fa-caret-down" aria-hidden="true"></i>
        </div>
        { dropDown }
        
      </div>
    )
  }

  return (
    <div className="LicenseSelector">
      { listingWrapper }
    </div>
  )

}

export default MenuBarLicenseSelector